import React from 'react';
import { useTranslation } from 'react-i18next';
import { PageTitle } from '@app/components/common/PageTitle/PageTitle';
import { ReportViewer } from '@app/components/eMIPs/Reports/ReportViewer';

export const ViewReportPage: React.FC = () => {
  const { t } = useTranslation();
  return (
    <>
      <PageTitle>{t('reports.viewReport')}</PageTitle>
      <ReportViewer />
    </>
  );
};